export default "<p>referidos works!</p>\r\n";